import { SVGProps, Ref, forwardRef } from 'react';

export const UserCircleOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.789 5.59C3.424 7.228 2.8 9.517 2.8 12s.624 4.772 1.989 6.41q.39.47.89.888C6.55 16.124 9.275 15 12 15s5.45 1.124 6.321 4.298q.5-.417.89-.888C20.576 16.772 21.2 14.483 21.2 12s-.624-4.772-1.989-6.41C17.894 4.01 15.692 2.8 12 2.8S6.106 4.01 4.789 5.59m11.915 14.716c-.215-1.24-.736-1.997-1.313-2.478-.815-.678-2.006-1.028-3.39-1.028s-2.577.35-3.391 1.028c-.578.481-1.1 1.238-1.314 2.478 1.21.554 2.748.894 4.704.894s3.494-.34 4.704-.894M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1m-1.742 6.902c-.271.326-.458.865-.458 1.598s.187 1.272.458 1.598c.223.267.675.602 1.742.602s1.52-.335 1.742-.602c.271-.326.458-.865.458-1.598s-.187-1.272-.458-1.598C13.52 7.635 13.067 7.3 12 7.3s-1.52.335-1.742.602M12 5.5c-3 0-4 2-4 4s1 4 4 4 4-2 4-4-1-4-4-4"
                fill="currentColor"
            />
        </g>
    </svg>
));
UserCircleOutlinedSize24Glyph.displayName = 'UserCircleOutlinedSize24Glyph';
